import type { FieldPolicy } from "@apollo/client"

export const layerCategoryCacheFields: Record<string, FieldPolicy> = {
  getLayerCategoryByFeatureCode: {
    merge: false,
    read(_, { args, toReference, canRead }) {
      if (!args?.input?.featureCode) return
      const ref = toReference({
        __typename: "LayerCategory",
        FeatureCode: args.input.featureCode,
      })
      if (ref && canRead(ref)) return ref
    },
  },
}
